<template>
  <div class="main-wrapper authendication-pages">
    <div class="content blur-ellipses login-password">
      <div class="container">
        <div class="row">
          <div
              class="col-xl-6 col-lg-6 col-md-7 mx-auto vph-100 d-flex align-items-center"
          >
            <div class="change-password w-100">
              <header class="text-center">
                <router-link to="/">
                  <img
                      alt="Logo"
                      class="img-fluid"
                      src="@/assets/img/logo_red.png"
                      style="max-width: 400px;"
                  />
                </router-link>
              </header>
              <div class="shadow-card">
                <h2>Đổi mật khẩu</h2>
                <p>
                  Mật khẩu mới của bạn phải khác với mật khẩu trước đó bạn sử
                  dụng
                </p>
                <!-- Login Form -->
                <Form
                    v-slot="{ errors }"
                    :validation-schema="schema"
                    @submit="onSubmit"
                >
                  <div class="form-group">
                    <div class="pass-group group-img">
                      <!-- <i class="toggle-password feather-eye"></i> -->
                      <Field
                          :class="{ 'is-invalid': errors.password }"
                          :type="showPassword ? 'text' : 'password'"
                          class="form-control pass-input"
                          name="password"
                          placeholder="Mật khẩu mới"
                      />
                      <span class="toggle-password" @click="toggleShow">
                                <i
                                    :class="
                                    showPassword
                                      ? 'fas fa-eye'
                                      : 'fas fa-eye-slash'
                                  "
                                ></i>
                              </span>
                      <div class="invalid-feedback">
                        {{ errors.password }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="pass-group group-img">
                      <!-- <i class="toggle-password-confirm feather-eye"></i> -->
                      <Field
                          :class="{ 'is-invalid': errors.confirmPassword }"
                          :type="showPassword1 ? 'text' : 'password'"
                          class="form-control pass-confirm"
                          name="confirmPassword"
                          placeholder="Xác nhận mật khẩu "
                      />
                      <span
                          class="toggle-password"
                          @click="toggleShow1"
                      >
                                <i
                                    :class="{
                                    'fas fa-eye': showPassword1,
                                    'fas fa-eye-slash': !showPassword1,
                                  }"
                                ></i>
                              </span>
                      <div class="invalid-feedback">
                        {{ errors.confirmPassword }}
                      </div>
                    </div>
                  </div>
                  <button
                      class="btn btn-secondary w-100 d-inline-flex justify-content-center align-items-center"
                      type="submit"
                  >
                    Đổi mật khẩu <i class="feather-arrow-right-circle ms-2"></i>
                  </button>
                </Form>
                <!-- /Login Form -->
              </div>
              <div class="bottom-text text-center">
                <p>
                  Đã có tài khoản?
                  <router-link to="/login">Đăng nhập!</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { Form, Field } from 'vee-validate';
import * as Yup from 'yup';
import { fetchWrapper } from '@/helpers/fetch-wrapper';

// State
const showPassword = ref(false);
const showPassword1 = ref(false);

// Validation schema
const schema = Yup.object({
  password: Yup.string()
      .min(6, 'Mật khẩu phải có ít nhất 6 ký tự')
      .max(50, 'Mật khẩu không được quá 50 ký tự')
      .required('Vui lòng nhập mật khẩu'),
  confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Mật khẩu không khớp')
      .required('Vui lòng xác nhận mật khẩu'),
});

// Functions
const toggleShow = () => {
  showPassword.value = !showPassword.value;
};

const toggleShow1 = () => {
  showPassword1.value = !showPassword1.value;
};

const onSubmit = async (values) => {
  try {
    console.log(values);

    const code = new URLSearchParams(window.location.search).get('code');
    console.log(code);

    if (!code) {
      alert('Không tìm thấy mã xác nhận. Vui lòng thử lại sau.');
      return;
    }

    const response = await fetchWrapper.post(
        `${import.meta.env.VUE_APP_SERVER_URL}/api/auth/reset-password`,
        {
          code: code,
          password: values.password,
          passwordConfirmation: values.confirmPassword,
        }
    );

    if (response.jwt) {
      alert('Mật khẩu của bạn đã được thay đổi thành công!');
      window.location.href = '/login';
    }
  } catch (error) {
    console.error('Error reset password:', error);
    alert('Có lỗi xảy ra. Vui lòng thử lại sau.');
  }
};
</script>
